<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
        md="8"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BFormInput
            id="filterSearch"
            v-model="tableBarangays.filter.search"
            placeholder="search here"
            autocomplete="off"
            debounce="1000"
            type="text"
          />
        </BFormGroup>
      </BCol>
      <BCol
        cols="12"
        md="4"
      >
        <BFormGroup
          label="Municipality"
          label-for="filterMunicipality"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <VSelect
            v-model="tableBarangays.selected.municipality"
            placeholder="filter municipality here"
            input-id="filterMunicipality"
            class="vs-white"
            label="municipality_name"
            clearable
            append-to-body
            :options="(tableBarangays.options.municipalities)"
            :loading="(tableBarangays.fetching.municipalities)"
            :disabled="(tableBarangays.busy || tableBarangays.fetching.municipalities)"
            :calculate-position="calculateDropPosition"
            @search="searchFilterMunicipalities"
          >
            <template #option="{ municipality_name, province }">
              <div
                class="text-break text-wrap"
                v-text="municipality_name"
              />
              <div
                v-if="province"
                class="text-muted small"
                v-text="province?.province_name"
              />
            </template>
            <template #selected-option="{ municipality_name }">
              <div
                class="w-225px w-md-100px w-lg-200px text-truncate"
                v-text="municipality_name"
              />
            </template>
            <template #no-options="">
              no available municipality
            </template>
          </VSelect>
        </BFormGroup>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableBarangays"
      :provider="tableProvider"
      :fields="tableBarangays.fields"
      :filter="tableBarangays.filter"
      :filter-on="tableBarangays.filterOn"
      :sort-by="tableBarangays.sortBy"
      :sort-desc="tableBarangays.sortDesc"
      :sort-direction="tableBarangays.sortDirection"
      :total-rows="tableBarangays.totalRows"
      :current-page="tableBarangays.currentPage"
      :per-page="tableBarangays.perPage"
      :stacked="tableBarangays.stacked"
      :busy="tableBarangays.busy"
    >

      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
          <BButton
            size="sm"
            :disabled="tableBarangays.busy"
            :variant="Number(item.active) === 1 ? 'danger' : 'primary'"
            @click.prevent="updateBarangay(item)"
          >
            {{ Number(item.active) === 1 ? 'Deactivate' : 'Activate' }}
          </BButton>
        </div>
      </template>
    </CustomTable>

    <BModal
      ref="modalBarangay"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      aria-hidden="false"
      role="dialog"
      :title="MBarangayTitle"
    >
      <ValidationObserver
        ref="formBarangay"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>
            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="barangay name"
                vid="barangay_name"
                rules="required|max:150"
              >
                <BFormGroup
                  label="Barangay Name"
                  label-for="fBarangayName"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fBarangayName"
                    v-model="formBarangay.barangay_name"
                    type="text"
                    maxlength="150"
                    autocomplete="off"
                    placeholder="enter barangay name here"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="municipality"
                name="municipality"
                rules="required"
              >
                <BFormGroup
                  label="Municipality"
                  label-for="fMunicipality"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <VSelect
                    v-model="selected.municipality"
                    input-id="fMunicipality"
                    label="municipality_name"
                    append-to-body
                    placeholder="search municipality here"
                    :options="options.municipalities"
                    :disabled="fetching.municipalities"
                    :loading="fetching.municipalities"
                    :calculate-position="calculateDropPosition"
                    :class="{ 'is-invalid': errors.length > 0 }"
                    @search="searchMunicipalities"
                  >
                    <template #no-options="">
                      no available municipality
                    </template>
                  </VSelect>
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              v-if="state.editing"
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="fActive"
                  v-model="formBarangay.active"
                  switch
                  value="1"
                  name="active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>
          </BRow>

        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <BButton
          variant="primary"
          :disabled="state.busy"
          @click.prevent="validateBarangay"
        >
          {{ state.editing ? 'Update Barangay' : 'Create Barangay' }}
        </BButton>
        <BButton
          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>

    </BModal>
  </BContainer>
</template>

<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MMunicipalities from '@/mixins/locations/municipalities'

import { SAdminBarangay } from '@/services/admin'

export default {
  name: 'VAdminBarangays',

  mixins: [
    MMunicipalities,
    MxMisc,
    MxFormatter
  ],

  middleware: [
    'auth',
    'admin'
  ],

  metaInfo: () => ({
    title: 'Barangays'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      formBarangay: {
        id: '',
        municipality: '',
        barangay_name: '',
        active: 1
      },
      tableBarangays: {
        busy: false,
        fetching: {
          municipalities: false
        },
        options: {
          municipalities: []
        },
        selected: {
          municipality: ''
        },
        filter: {
          search: '',
          municipality: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 4, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'barangay_name', class: 'min-w-175px' },
          { mobile: 2, key: 'municipality.municipality_name', label: 'Municipality', class: 'min-w-175px' },
          { mobile: 2, key: 'active', class: 'text-md-center w-md-75px', formatter: this.yesOrNo },
          { mobile: 3, key: 'updated_at', class: 'min-w-150px', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: Object.assign({
    MBarangayTitle () {
      return this.state.editing ? 'Edit Barangay' : 'Create Barangay'
    }
  }, mapGetters({
    currentUser: 'auth/user'
  })),

  watch: {
    'selected.municipality' (municipality) {
      this.formBarangay.municipality = municipality?.id || ''
    },
    'tableBarangays.selected.municipality' (municipality) {
      this.tableBarangays.filter.municipality = municipality?.id || ''
    }
  },

  mounted () {
    if (this.currentUser) {
      this.getMunicipalities(this.tableBarangays)
    }
  },

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableBarangays.busy = true
      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        municipality: filter.municipality
      }

      return await SAdminBarangay.get(payload).then(
        ({ data }) => {
          this.tableBarangays.totalRows = data.total_rows
          return data.items
        }
      ).catch(() => {
        this.tableBarangays.totalRows = 0
        return []
      }).finally(() => {
        this.tableBarangays.busy = false
      })
    },

    async searchFilterMunicipalities (search, loading) {
      this.searchMunicipalitiesProvider(this.tableBarangays, search, loading)
    },

    createBarangay () {
      this.state.editing = false
      this.formBarangay = Object.assign(this.formBarangay, {
        id: '',
        municipality: '',
        barangay_name: '',
        active: 1
      })

      this.getMunicipalities(this)

      this.$refs.modalBarangay.show()
    },

    editBarangay (barangay) {
      this.state.editing = true
      this.formBarangay = Object.assign(this.formBarangay, {
        id: barangay.id,
        municipality: barangay.municipality_id,
        barangay_name: barangay.barangay_name,
        active: barangay.active
      })

      this.getMunicipalities(this).finally(() => {
        this.selected.municipality = QUERY.find(this.options.municipalities, {
          id: barangay.municipality_id
        })
      })

      this.$refs.modalBarangay.show()
    },

    async updateBarangay (barangay) {
      const isActive = Number(barangay.active) === 1

      this.formBarangay = Object.assign(this.formBarangay, {
        id: barangay.id,
        municipality: barangay.municipality_id,
        barangay_name: barangay.barangay_name,
        active: isActive ? 0 : 1
      })

      this.swalConfirm({
        html: isActive ? '<h6>Deactivate this Barangay?</h6>' : '<h6>Activate this Barangay?</h6>',
        confirmButtonText: isActive ? 'Deactivate' : 'Activate',
        customClass: {
          confirmButton: isActive ? 'btn btn-sm btn-danger' : 'btn btn-sm btn-primary'
        },
        preConfirm: async () => {
          this.state.busy = true
          return this.putBarangay().finally(() => {
            this.state.busy = false
          })
        }
      })
    },

    async validateBarangay () {
      await this.$refs.formBarangay.validate().then(
        async validBarangay => {
          if (!validBarangay) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: this.state.editing ? '<h6>Update this Barangay?</h6>' : '<h6>Create this Barangay?</h6>',
            confirmButtonText: this.state.editing ? 'Update' : 'Create',
            preConfirm: async () => {
              this.state.busy = true

              const createOrUpdate = async () => {
                return this.state.editing ? this.putBarangay() : this.postBarangay()
              }

              return createOrUpdate().catch(
                ({ message }) => {
                  this.$refs.formBarangay.setErrors(message.errors)
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    async postBarangay () {
      return await SAdminBarangay.post(this.formBarangay).then(
        ({ data: { message } }) => {
          this.swalSuccess(message).then(() => {
            this.$refs.modalBarangay.hide()
            this.$refs.tableBarangays.refetch()
          })
        }
      )
    },

    async putBarangay () {
      return await SAdminBarangay.put(this.formBarangay).then(
        ({ data: { message, barangay } }) => {
          this.swalSuccess(message).then(() => {
            this.$refs.modalBarangay.hide()
            this.$refs.tableBarangays.updateRow({
              id: barangay.id,
              municipality: barangay.municipality,
              municipality_id: barangay.municipality_id,
              barangay_name: barangay.barangay_name,
              active: barangay.active,
              updated_at: barangay.updated_at
            })
          })
        }
      )
    }
  }
}
</script>
